import './AllUploadedFiles.css'
import { Amplify, Storage } from "aws-amplify";
import DeleteFile from "./DeleteFile";
import awsconfig from "../aws-exports";
import { useState, useEffect } from "react";
import DownloadFile from "./DownloadFile";
import UploadBook from './UploadBook';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import Tooltip from '@mui/material/Tooltip';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import SearchIcon from '@mui/icons-material/Search';
import { BiArrowBack } from 'react-icons/bi'
import { FcFolder } from 'react-icons/fc'
import { FiEdit3 } from 'react-icons/fi'
import { FiFileText } from 'react-icons/fi'
import CreateDirectory from './CreateDirectory';
// import DisplayFile from './DisplayFile';
Amplify.configure(awsconfig);

function AllUploadedFiles(props) {

  // const { bucketname } = props

  const [files, setFiles] = useState([]);
  const [reloadAllUploadedFilesPage, setReloadAllUploadedFilesPage] = useState({})
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [paginationArray, setPaginationArray] = useState([])
  const [searchtext, setSearchtext] = useState('')
  const [currentPath, setCurrentPath] = useState('');
  const [folders, setFolders] = useState([]);
  // const [clickedFileKey, setClickedFileKey] = useState('')

  const loadFiles = async () => {
    try {
      let response = await Storage.list(currentPath, {
        // bucket: bucketname,
        level: 'private',
      });
      const foldersSet = new Set();
      const filesList = [];
      // console.log(response)

      response.results.forEach(item => {
        const parts = item.key.replace(currentPath, '').split('/').filter(Boolean);

        if (parts.length === 1 && !item.key.endsWith('/')) {
          filesList.push(item);
        } else if (parts.length === 1 && item.key.endsWith('/')) {
          foldersSet.add(parts[0]);
        } else {
          foldersSet.add(parts[0]);
        }
      });

      const foldersList = [...foldersSet];
      setFiles(filesList);
      setFolders(foldersList);
      decidePaginationArray(response.results.length)
    } catch (error) {
      console.error("Error loading files:", error);
    }
  }

  useEffect(() => {
    loadFiles()
  }, [/*bucketname,*/ currentPath, reloadAllUploadedFilesPage])

  function handleAfterDelete(key) {
    setFiles((previousFiles) => previousFiles.filter(file => file.key !== key))
    loadFiles()
  }

  function onNewFileUploadHandler(reloadAllUploadedFilesPage) {
    setReloadAllUploadedFilesPage(reloadAllUploadedFilesPage)
    loadFiles()
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  function decidePaginationArray(filesLength) {
    if (filesLength <= 5) {
      setPaginationArray([5])
    }
    if (filesLength <= 10 && filesLength > 5) {
      setPaginationArray([5, 10])
    }
    if (filesLength <= 25 && filesLength > 10) {
      setPaginationArray([5, 10, 25])
    }
    if (filesLength <= 50 && filesLength > 25) {
      setPaginationArray([5, 10, 25, 50])
    }
    if (filesLength <= 100 && filesLength > 50) {
      setPaginationArray([5, 10, 25, 50, 100])
    }
  }

  // function displayContentHandler(key) {
  //   setClickedFileKey(key)
  //   isToShowContent===true?setIsToShowContent(false):setIsToShowContent(true)
  // }

  const navigateToFolder = (folder, event) => {
    if (event.detail === 2) {
      setCurrentPath(`${currentPath}${folder}/`);
    }
  };

  const navigateBack = () => {
    if (!currentPath) return;
    if (currentPath.length === 0) return;
    const parts = currentPath.split('/').filter(Boolean);
    setCurrentPath((prevPath) => prevPath.replace(parts[parts.length - 1] + '/', ''))
  };

  const columns = [
    {
      id: 'file',
      label: 'File',
      minWidth: 170,
      align: 'left',
      paddingLeft: 40,
      borderRadius: '0.7vw 0 0 0.7vw',
    },
    {
      id: 'date',
      label: 'Date',
      minWidth: 170,
      align: 'center',
      paddingLeft: 0,
      borderRadius: '0',
    },
    {
      id: 'action',
      label: 'Action',
      minWidth: 170,
      align: 'center',
      paddingLeft: 20,
      borderRadius: '0 0.7vw 0.7vw 0',
    },
  ];

  const useStyle = {

    mainContainer__paper: {
      borderRadius: '1vw',
      width: '80%',
      overflow: 'hidden',
    },

    mainContainer__search: {
      border: '1px solid lightgray',
      borderRadius: '0.7vw',
      display: 'flex',
      alignItems: 'center',
    },

    subSection__tableContainer: {
      maxHeight: 440,
    },

    tableHead__tableCell: {
      color: '#637381',
      background: '#F4F6F8',
      border: 'none',
      borderRadius: '0.7vw',
    },

    tableBody__tableCell: {
      border: 'none',
      color: '#637381'
    },

  }

  return (<>
    <div className='main-container'>
      <h3>Documents</h3>
      <Paper sx={useStyle.mainContainer__paper}>
        <div className='all-files'>{currentPath.length === 0 ? 'All files' : currentPath}</div>
        <div className='sub-container'>
          <div className='search-upload-section'>
            <div className="upload-create-comp">
              <CreateDirectory /*bucketname={bucketname}*/ currentPath={currentPath} onNewFileUpload={(reloadAllUploadedFilesPage) => { onNewFileUploadHandler(reloadAllUploadedFilesPage) }} />
              <UploadBook /*bucketname={bucketname}*/ currentPath={currentPath} onNewFileUpload={(reloadAllUploadedFilesPage) => { onNewFileUploadHandler(reloadAllUploadedFilesPage) }} />
            </div>
            <div className="search-input">
              <SearchIcon className='search-icon' />
              <input onChange={(event) => { setSearchtext(event.target.value.toLowerCase()) }} type="text" placeholder='Search...' />
            </div>
          </div>
          <TableContainer sx={useStyle.subSection__tableContainer}>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell
                      key={column.id}
                      align={column.align}
                      style={{ zIndex: 999, minWidth: column.minWidth, paddingLeft: column.paddingLeft, borderRadius: column.borderRadius }}
                      sx={useStyle.tableHead__tableCell}
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <div id='back-directory'>
                <Tooltip title="Click to go back" placement='top-end'>
                  <button id='back-directory-button' onClick={navigateBack}><BiArrowBack id='back-directory-button__left-arrow' /></button>
                </Tooltip>
              </div>
              <TableBody>
                {folders
                  .filter(folder => folder !== undefined && folder !== null)
                  .filter((folder) => folder.toLowerCase().includes(searchtext))
                  .map(folder => folder !== null ?
                    <TableRow key={folder} onClick={(event) => event.detail === 2 ? navigateToFolder(folder, event) : null} hover role="checkbox" style={{ cursor: 'pointer' }} tabIndex={-1}>
                      <TableCell align={'left'} colSpan={2} sx={useStyle.tableBody__tableCell} style={{ minWidth: 170, paddingLeft: 40, }}>
                        <FcFolder id='folder-icon' /> <span id='filenames-in-list'>{folder}</span>
                      </TableCell>
                      <TableCell align={'center'} sx={useStyle.tableBody__tableCell} style={{ minWidth: 170, width: 90 }}>
                        {/* <FiEdit3 id='edit_folder_icon' /> */}
                        <DownloadFile /*bucketname={bucketname}*/ file={folder} />
                        <DeleteFile /*bucketname={bucketname}*/ file={currentPath + folder} onDelete={handleAfterDelete} currentPath={currentPath} />
                      </TableCell>
                    </TableRow>
                    : '')}
                {files
                  .filter((file) => file.key.toLowerCase().includes(searchtext))
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((file) => {
                    if (file.key.charAt(file.key.length - 1) !== '/') {
                      return <>
                        <TableRow key={file.key} /*onClick={() => displayContentHandler(file.key)}*/ hover role="checkbox" tabIndex={-1}>
                          <TableCell align={'left'} sx={useStyle.tableBody__tableCell} style={{ minWidth: 170, paddingLeft: 40, }}>
                            <FiFileText id='file-icon' /> <span id='filenames-in-list'>{file.key.slice(currentPath.length)}</span>
                          </TableCell>
                          <TableCell align={'left'} sx={useStyle.tableBody__tableCell} style={{ minWidth: 170, width: 275 }}>
                            <div className='modified-date'>{file.lastModified.toLocaleString('en-IN', { month: 'long', year: 'numeric', day: '2-digit', weekday: 'short', hour: '2-digit', minute: '2-digit', hour12: true })}</div>
                          </TableCell>
                          <TableCell align={'center'} sx={useStyle.tableBody__tableCell} style={{ minWidth: 170, width: 30 }}>
                            <DownloadFile /*bucketname={bucketname}*/ file={file} />
                            <DeleteFile /*bucketname={bucketname}*/ file={file} onDelete={handleAfterDelete} currentPath={currentPath.toString()} />
                          </TableCell>
                        </TableRow>
                      </>
                    }
                    else {
                      return ''
                    }
                  }
                  )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={paginationArray}
            component="div"
            count={files.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>
      </Paper >
    </div >
    {/* <DisplayFile clickedFileKey={clickedFileKey} isToShowContent={isToShowContent}/> */}
  </>)
}

export default AllUploadedFiles
